
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/core-exchange/docs/migrating-from-plaid-exchange/backend-token-exchange",
      function () {
        return require("private-next-pages/core-exchange/docs/migrating-from-plaid-exchange/backend-token-exchange/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/core-exchange/docs/migrating-from-plaid-exchange/backend-token-exchange"])
      });
    }
  